import * as React from "react";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [username, setUsername] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState("");

  const validateUsername = (username) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(username);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateUsername(username)) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    setSubmitted(true);
  };

  return (
    <div className="tyn-root">
      <div className="tyn-content tyn-auth tyn-auth-centered">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-4 col-lg-5 col-md-7 col-sm-9">
              <div className="card border-0 py-4">
                <div className="my-3 text-center d-flex align-items-center justify-content-center">
                  <Link className="tyn-logo tyn-logo-sm" to="/">
                    <img
                      src="/images/logo/bardo-icon.png"
                      alt="Bardo logo"
                      className="logo-icon"
                    />
                    <img
                      src="/images/logo/bardo-text.png"
                      alt="Bardo logo"
                      className="logo-text"
                    />
                  </Link>
                </div>

                {!submitted ? (
                  <>
                    <div className="p-4">
                      <h3>Forgot Your Password?</h3>
                      <p style={{ fontSize: "12px" }}>
                        No worries! Just enter your email, and we'll send you a link to reset your password.
                      </p>
                      <form className="row g-3" onSubmit={handleSubmit}>
                        <div className="col-12">
                          <div className="form-group">
                            {error && <p className="text-danger small">{error}</p>}

                            <label className="form-label" htmlFor="email-address">
                              Email Address
                            </label>
                            <div className="form-control-wrap">
                              <input
                                type="text"
                                className="form-control"
                                id="email-address"
                                placeholder="youremail@example.com"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <button className="btn btn-primary w-100" type="submit">
                            Send Reset Link
                          </button>
                        </div>
                      </form>
                    </div>
                    <div className="text-center mt-3 my-3 ">
                      <p>
                        Remembered your password? {" "}
                        <Link
                          to="/login"
                          className="link link-primary"
                          style={{ fontSize: "16px" }}
                        >
                          Log In.
                        </Link>
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="p-4 text-center">
                      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="#2c629b" className="bi bi-envelope-check-fill" viewBox="0 0 16 16">
                        <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 4.697v4.974A4.5 4.5 0 0 0 12.5 8a4.5 4.5 0 0 0-1.965.45l-.338-.207z" />
                        <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686" />
                      </svg>
                      <p className="text-success text-center pt-3" style={{ fontWeight: "500" }}>Check your email for the reset link!</p>
                    </div>
                    <div className="text-center my-3 ">
                      <p>
                        Remembered your password? {" "}
                        <Link
                          to="/login"
                          className="link link-primary"
                          style={{ fontSize: "16px" }}
                        >
                          Log In.
                        </Link>
                      </p>
                    </div>
                  </>

                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;